<script lang="ts">
  import Popover from "@shared/svelte/Components/Popover/Popover.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  export let trueUserDisplayName;
  export let accountDisplayName;
  export let trueUser;
  export let user;
  export let logout;

  const navToUser = () => {
    //@ts-ignore
    window.location = "/distributor/profile";
  };

</script>

<style>
  .padding-top {
    padding-top: 5px;
  }
  .padding-left {
    padding-left: 10px;
  }
  .padding-bottom {
    padding-bottom: 5px;
  }
  .fizz-border-none {
    border: 0px !important;
  }
  .fizz-color-black {
    color: #000000;
  }

</style>

<div>
  <div class="fizz-flex fizz-flex-row">
    <div>
      <Popover arrow={false} placement="bottom-end" let:setOpen>
        <div slot="target" class="cursor-pointer fizz-flex-row-4" data-testid="usernavbaropen">
          <span class="fizz-text-regular">
            {accountDisplayName}
          </span>
          <Icon
            type="ChevronDown"
            height="12"
            width="12"
            extraClassNames="fizz-text-inverse fizz-icon cursor-pointer"
          />
        </div>
        <div slot="content" class="retailer-header__account-popover__contents fizz-popover">
          <ul class="fizz-text-large fizz-color-black">
            {#if (trueUser && trueUser.id != user.id) || user.admin}
              <li class="color-black fizz-inset-square-16">
                {#if trueUser && trueUser.id == user.id}
                  <a class="cursor-pointer underline-hover display-block" href="/admin">Admin</a>
                {/if}
                {#if trueUser && trueUser.id != user.id}
                  <div class="default-small--bold">
                    {trueUserDisplayName} logged in as {accountDisplayName}
                  </div>
                {/if}
              </li>
            {/if}
            <li class="list-item hr" />
            <li class="underline-hover fizz-border-none" on:click={setOpen}>
              <!-- svelte-ignore a11y-invalid-attribute -->
              <a href="#" on:click|preventDefault={navToUser} class="fizz-inset-square-4">
                <div class="fizz-flex-row fizz-inset-square-8">
                  <Icon
                    extraClassNames="fizz-text-inverse fizz-icon cursor-pointer"
                    type="User"
                    height="20"
                    width="20"
                  />
                  <div>Profile</div>
                </div>
              </a>
            </li>

            <li class="list-item hr" />
            <li
              on:click={() => {
                setOpen();
                logout();
              }}
            >
              <!-- svelte-ignore a11y-invalid-attribute -->
              <a href="/supplier">
                <div class="fizz-inset-square-16 padding-top padding-left padding-bottom">
                  Logout
                </div>
              </a>
            </li>
          </ul>
        </div>
      </Popover>
    </div>
  </div>
</div>
